/** 子账号购买API **/
import { config } from "@/utils/config";
import { omniAxios } from "@/utils/axios";

//获取是否可以弹框
export function restPayPayDialogInfoNeedBuyMoreDialog({ type }) {
  return omniAxios({
    url: config.restPayPayDialogInfoNeedBuyMoreDialogPath,
    method: "post",
    params: { type },
  });
}
//获取弹框信息
export function restPayPayDialogInfoGetBuyMoreChildAccountDialogInfo() {
  return omniAxios({
    url: config.restPayPayDialogInfoGetBuyMoreChildAccountDialogInfoPath,
    method: "get",
  });
}
//支付弹框点击埋点
export function restPayPayDialogClickPayBtn(params) {
  return omniAxios({
    url: config.restPayDialogClickPaybtnPath,
    method: "post",
    params,
    disableErrorMessage: true,
  });
}
// 支付弹框曝光埋点
export function restPayPayDialogShow(params) {
  return omniAxios({
    url: config.restPayDialogShowPath,
    method: "post",
    params,
    disableErrorMessage: true,
  });
}
// 获取支付二维码及信息
export function restPayPayBuyMoreGetPayQrCode(params) {
  return omniAxios({
    url: config.restPayPayBuyMoreGetPayQrCodePath,
    method: "post",
    params,
  });
}
// 支付二维码状态
export function restEnterprisePayServicePayState(params) {
  return omniAxios({
    url: config.restEnterprisePayservicePayStatePath,
    method: "get",
    params,
  });
}
//获取订单详情
export function restPayPayBuyMoreGetOrderDetail({ orderId }) {
  return omniAxios({
    url: config.restPayPayBuyMoreGetOrderDetailPath,
    method: "post",
    params: { orderId },
  });
}
